import { cn } from '@Utils/cn';
import type { GuestTabOption } from '../types';

export interface GuestTabRailProps<T extends string = string> {
  tabs: GuestTabOption<T>[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  className?: string;
}

/**
 * Horizontal tab rail styled for the dark guest surfaces — the flow drawer and
 * the fish details page. Pass `scrollbar-dark overflow-x-auto` via className
 * when the tab list is long enough to need horizontal scrolling.
 */
export function GuestTabRail<T extends string = string>({
  tabs,
  activeTab,
  onTabChange,
  className,
}: GuestTabRailProps<T>) {
  return (
    <div className={cn('flex gap-1', className)}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          onClick={() => onTabChange(tab.value)}
          className={cn(
            'flex shrink-0 items-center gap-2 px-4 py-3 text-sm font-medium transition-colors',
            activeTab === tab.value
              ? 'border-b-2 border-aoh-accent text-aoh-ink dark:border-[#caab6a] dark:text-white'
              : 'text-aoh-muted hover:text-aoh-ink dark:text-zinc-400 dark:hover:text-zinc-200',
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
